<template>
    <div class="page">
        <strong>Date:</strong> {{ date }}
        <br />
        <br />
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
            <br /> {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }}
            <br />
            <br />
            {{ userStore.user.dob }} | {{ userStore.user.ssn }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p class="letter-content">
            To Whom It May Concern:
        </p>
        <p class="letter-content">
            I am writing to dispute the account referenced below.
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number 
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
            </strong>
            <template v-if="creditor.reason">
                <br />
                {{ creditor.reason }}
            </template>
        </p>
        <p class="letter-content">
            I have contacted the collection agency myself and have been unable to get them to verify that this is indeed my debt.
        </p>
        <p class="letter-content">
            I have enclosed copies of my requests to the collection agency, asking them to validate my debts, and the receipts showing
             that I sent these letters certified signature request. 
             I was provided no evidence of validation and/or my obligation to pay this debt to this collection agency.
        </p>
        <p class="letter-content">
            The FCRA requires you to provide verification of disputed accounts within 30 days. 
            If the verification cannot be correctly and lawfully completed, you are required by law to remove the disputed item.
        </p>
        <p class="letter-content">
            I demand that you VERIFY this information and provide me with copies of any documentation associated with any disputed account bearing my signature. 
            In the absence of any such documentation bearing my signature, I demand that this information be immediately removed from the credit file you maintain under my Social Security Number.
        </p>
        <p class="letter-content">
            Should you continue in your non-compliance, the law is very clear as to the civil liability and the remedy available to me for “negligent non-compliance”.
             I am maintaining a careful record of my communications with you for the purpose of filing a complaint seeking relief and monetary damages under FCRA Sections 616 and 617.
        </p>
        <p style="page-break-after: always;">
            Sincerely, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
